import type * as React from 'react'

function Sweden24(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.2026 4.13794H1.79742C0.804703 4.13794 0 4.94264 0 5.93536V18.0647C0 19.0574 0.804703 19.8622 1.79742 19.8622H22.2026C23.1952 19.8622 24 19.0575 24 18.0647V5.93536C24 4.94264 23.1953 4.13794 22.2026 4.13794Z"
        fill="#4173CD"
      />
      <path d="M24 10.7586H9.93103V4.13794H7.4483V10.7586H0V13.2414H7.4483V19.8621H9.93103V13.2414H24V10.7586Z" fill="#FFE15A" />
    </svg>
  )
}

export default Sweden24
